"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionBefore = questionBefore;
exports.chosenOption = chosenOption;
exports.replayedAnswer = replayedAnswer;
/**
 * A reply that says something, rather than the marker left when a turn came to nothing.
 *
 * An answer clicked again lands AFTER the apology, not after its question, so a failed turn has to
 * be stepped over when looking backwards for what a message was answering.
 */
const isRealReply = (m) => m.role === 'assistant' && m.data?.kind !== 'turn-failed';
/** The question a message at `index` may be answering: the nearest real reply before it. */
function questionBefore(messages, index) {
    for (let i = index - 1; i >= 0; i -= 1) {
        if (isRealReply(messages[i]))
            return messages[i];
    }
    return null;
}
/**
 * The option a user's message picked, when it was a button click rather than typing.
 *
 * Clicking sends the option's `value`, so an exact match against the preceding question's options
 * is what identifies the click. Free text typed into "Something else…" matches nothing and comes
 * back null, as it should.
 */
function chosenOption(content, question) {
    if (!question || question.role !== 'assistant' || question.data?.kind !== 'choice')
        return null;
    return question.data.options.find((option) => option.value === content) ?? null;
}
/**
 * What a clicked answer should look like in the history replayed to the model.
 *
 * THE BUG THIS FIXES. Clicking a button sends the option's `value`, and the value is whatever the
 * model invented when it built the menu — `SOCIAL_SET`, `LINKEDIN_alloterralabs`. The history
 * replayed on the next turn carried only that token, and the assistant turn that DEFINED it (the
 * tool call holding the option list) is not replayed at all. So a settled decision reached the
 * model as an opaque word with its meaning nowhere in context:
 *
 *     assistant: Where do you want this post to live?
 *     user:      SOCIAL_SET
 *     assistant: Which connected accounts should this social post be written for?
 *     user:      LINKEDIN_alloterralabs
 *
 * Asked later what to write, the model had one answer it could still read — a named LinkedIn
 * account — and one it could only guess at. It wrote for LinkedIn alone, dropping the full social
 * set the user had chosen two turns earlier.
 *
 * Replaying the LABEL puts the user's actual words back in context: "Full social set" is no longer
 * outweighed by the one answer that stayed legible. The value is kept alongside it because the
 * flows do act on it — a channel enum, an account id — and dropping it would trade one silent loss
 * for another.
 */
function replayedAnswer(content, question) {
    const picked = chosenOption(content, question);
    const label = picked?.label.trim();
    if (!label)
        return content;
    // Nothing to add when the model used the label as the value, which it does for plain-English
    // options like "Write Content" — repeating it would only read as a stutter.
    return label === content ? content : `${label} (${content})`;
}
//# sourceMappingURL=chatAnswers.js.map